import { Component } from '@angular/core';

@Component({
  selector: 'oes-theme-rrea',
  templateUrl: './rrea.component.html',
  styleUrls: ['./rrea.component.scss']
})
export class RreaComponent {

  constructor() { }

}
